import { APP_NAME } from "../../config";

export const updates = [
	{
		version: "3.10.9",
		changes: [
			{
				icon: "🛡️",
				title: "Correção: Alerta de Atendimento Indo para o Cliente",
				content: "Corrigido bug crítico onde o alerta de intervenção humana podia ser entregue na conversa do próprio cliente, em vez do número de alerta cadastrado. Agora o sistema valida o destino do alerta, rejeita números inválidos e nunca envia o aviso interno para o chat do cliente.",
			},
			{
				icon: "🌌",
				title: "Correção: Gemini Travava Sem Functions Cadastradas",
				content: "Corrigido bug onde o Gemini podia falhar ao responder quando nenhuma function/ferramenta estava cadastrada, devido a um erro de escopo nas variáveis de telemetria. Agora o Gemini responde normalmente com ou sem functions configuradas."
			},
			{
				icon: "🤖",
				title: "Correção: Erro no oZap AI",
				content: "Melhorada a estabilidade do oZap AI no tratamento de falhas, evitando que problemas pontuais resultassem em tentativas repetidas sem resposta. As respostas voltam a funcionar normalmente mesmo após uma falha temporária."
			},
			{
				icon: "📨",
				title: "Detecção de Mensagens Não Entregues",
				content: "Novo sistema que detecta quando uma mensagem enviada pela IA é rejeitada pelo WhatsApp e não chega ao cliente (as chamadas 'mensagens-fantasma'). Agora essas mensagens são sinalizadas com um aviso de 'não entregue' no chat e podem disparar um alerta, evitando que conversas sejam perdidas silenciosamente.",
				isHighlight: true
			}
		]
	},
	{
		version: "3.10.8",
		changes: [
			{
				icon: "⚡",
				title: "oZap AI mais robusto (nova engine de IA)",
				content: "A IA gratuita do app (oZap AI) passou a rodar em uma nova infraestrutura na Amazon (AWS Bedrock), com o modelo Nova — respostas de texto e leitura de imagens mais consistentes, com a mesma facilidade de sempre.",
				isHighlight: true
			},
			{
				icon: "🎙️",
				title: "Nova voz brasileira nos áudios do oZap AI",
				content: "As respostas em áudio do oZap AI agora usam uma voz neural em português brasileiro (Amazon Polly), com pronúncia mais natural.",
				isHighlight: true
			},
			{
				icon: "🗣️",
				title: "Transcrição de áudios aprimorada",
				content: "A transcrição de mensagens de voz recebidas no oZap AI passou a usar o Amazon Transcribe, melhorando o reconhecimento de fala em português."
			},
			{
				icon: "🧠",
				title: "Novos modelos Claude: Opus 4.8 e Opus 4.7",
				content: "Adicionados o Claude Opus 4.8 (modelo mais capaz da Anthropic, com raciocínio e capacidade de agente de ponta) e o Claude Opus 4.7 às opções do provedor Claude — junto dos já disponíveis Opus 4.6, Sonnet 4.6 e Haiku 4.5.",
				isHighlight: true
			}
		]
	},
	{
		version: "3.10.7",
		changes: [
			{
				icon: "📱",
				title: "Conexão via Código de Pareamento",
				content: "Nova alternativa ao QR Code! Agora você pode conectar seu WhatsApp digitando o número de telefone e inserindo um código de 8 dígitos diretamente no app (Dispositivos conectados → Conectar com número de telefone). Ideal para quem tem dificuldade em escanear QR Code.",
				isHighlight: true
			},
			{
				icon: "💾",
				title: "Correção: Functions Sumindo ao Importar/Atualizar",
				content: "Tentiva de corrigir o bug onde as functions cadastradas eram perdidas ao importar configurações de outra instância ou atualizar o app.",

			},
			{
				icon: "🤖",
				title: "Correção: Bot Respondia Mensagens Antigas Após Reconexão",
				content: "Corrigido bug onde mensagens recebidas antes da conexão eram processadas pela IA, causando respostas fora de contexto."
			},
			{
				icon: "🔁",
				title: "Correção: Chamadas Duplicadas em APIs Externas",
				content: "Corrigido bug onde a IA podia chamar a mesma function duas vezes em sequência rápida.",

			},
			{
				icon: "🛡️",
				title: "Correção: Alucinações do GPT por Prompt Injection",
				content: "Corrigido problema onde APIs externas podiam injetar instruções no contexto da IA."
			}
		]
	},
	{
		version: "3.10.6",
		changes: [
			{
				icon: "📢",
				title: "Mudamos o numero de suporte para WhatsApp",
				content: "Atualizamos nosso número de suporte para WhatsApp! Agora você pode entrar em contato conosco pelo número +55 53 99177-4147 para obter assistência rápida e personalizada. Salve nosso novo número para garantir que suas dúvidas e solicitações sejam atendidas com a atenção que você merece. Estamos ansiosos para continuar oferecendo o melhor suporte possível para você e seu negócio!",
				isHighlight: true
			}
		]
	},
	{
		version: "3.10.5",
		changes: [
			{
				icon: "🤖",
				title: "Novo Provedor de IA: Claude (Anthropic)",
				content: "Adicionado suporte ao Claude da Anthropic! Agora você pode usar os modelos Claude Opus 4.6, Claude Sonnet 4.6 e Claude Haiku 4.5 para automatizar suas conversas no WhatsApp. Claude se destaca por raciocínio avançado, seguimento preciso de instruções e respostas mais naturais em português.",
				isHighlight: true
			},
			{
				icon: "🚀",
				title: "Atualização de Modelos de IA",
				content: "Modelos atualizados: GPT-5.4 da OpenAI e família Gemini 3.x do Google (Gemini 3.0 Flash e Gemini 3.0 Pro). Removidos modelos descontinuados para garantir compatibilidade e performance otimizada.",
				isHighlight: true
			},
			{
				icon: "📊",
				title: "Sistema de Métricas e Kanban de Leads",
				content: "Implementado painel de métricas com visualização por instância individual ou visão geral de todas. Adicionado kanban de qualificação de leads para organizar e acompanhar o funil de vendas de cada conversa."
			},
			{
				icon: "📅",
				title: "Mídia em Mensagens Agendadas para Grupos",
				content: "Agora é possível enviar imagens, vídeos e documentos em mensagens agendadas para grupos! Ideal para campanhas promocionais e comunicações massivas com mídia rica."
			},
			{
				icon: "🔧",
				title: "Correção: Bot Respondia Mensagens Antigas",
				content: "Corrigido bug onde o bot respondia mensagens enviadas antes da conexão ao WhatsApp. Agora apenas mensagens novas recebidas após a conexão são processadas pela IA, evitando respostas duplicadas ou fora de contexto."
			}
		]
	},
	{
		version: "3.10.4",
		changes: [
			{
				icon: "📢",
				title: "Melhoria: Recebimento de Mensagens de Anúncios (Meta Ads)",
				content: "Aprimorado o sistema de extração de mensagens para garantir que todas as mensagens vindas de anúncios do Facebook e Instagram (Click to WhatsApp) sejam corretamente recebidas e processadas pela IA. Implementado sistema unificado de desempacotamento de mensagens que navega por todas as camadas possíveis do protocolo do WhatsApp (ephemeralMessage, viewOnceMessage, deviceSentMessage, extendedTextMessage com metadados de anúncio). Adicionado logging automático quando uma mensagem de anúncio é detectada, facilitando diagnóstico de problemas.",
				isHighlight: true
			},
			{
				icon: "🔧",
				title: "Correção: Extração de Texto em Mensagens Complexas",
				content: "Corrigido bug onde mensagens com estruturas complexas (botões interativos, listas, templates, mensagens editadas) não eram processadas pela IA. O sistema agora extrai texto de todas as variantes possíveis de mensagem do WhatsApp, incluindo buttonsResponseMessage, templateButtonReplyMessage, listResponseMessage e interactiveResponseMessage."
			},
			{
				icon: "🔗",
				title: "Correção: QR Code Não Aparecia",
				content: "Corrigido bug crítico onde o QR Code não era gerado ao conectar ao WhatsApp. O problema ocorria porque a versão do protocolo do WhatsApp estava fixa no código e ficou obsoleta após atualização dos servidores. Agora o sistema busca automaticamente a versão mais recente do protocolo, garantindo que a conexão e o QR Code funcionem mesmo após atualizações do WhatsApp.",
				isHighlight: true
			}
		]
	},
	{
		version: "3.10.3",
		changes: [
			{
				icon: "📢",
				title: "Correção: IA Agora Responde Mensagens de Anúncios",
				content: "Corrigido bug onde mensagens vindas de anúncios do Facebook e Instagram (Click to WhatsApp) não eram recebidas pela IA. O problema era uma limitação do protocolo do WhatsApp que não encriptava essas mensagens para dispositivos vinculados. Atualizado Baileys para versão com suporte a placeholder resend, permitindo que a IA responda automaticamente leads de campanhas de ads.",
				isHighlight: true
			},
			{
				icon: "🔧",
				title: "Correção: Contatos Sem Nome Não Recebiam Resposta",
				content: "Corrigido bug crítico onde contatos novos ou sem nome cadastrado (pushName) não recebiam resposta da IA. O problema ocorria porque o WhatsApp envia metadados extras (senderKeyDistributionMessage) na primeira mensagem de novos contatos, e o sistema identificava incorretamente o tipo da mensagem. Agora o sistema desempacota automaticamente wrappers do WhatsApp para detectar o tipo real da mensagem.",
			},
			{
				icon: "⏰",
				title: "Horário Comercial para Follow-up",
				content: "Nova opção para configurar horário permitido de envio de follow-ups! Defina horário de início e fim para evitar que mensagens de reengajamento sejam enviadas de madrugada. Follow-ups fora do horário são automaticamente reagendados para o próximo horário permitido.",
				isHighlight: true
			},
			{
				icon: "🤖",
				title: "Correção: Follow-up com Mensagens Genéricas",
				content: "Corrigido bug onde o follow-up enviava mensagens genéricas ao invés de usar a IA para gerar mensagens personalizadas baseadas no prompt configurado. Implementado sistema de fallback robusto com 3 camadas de proteção para garantir que a IA sempre gere a mensagem correta."
			}
		,
			{
				icon: "🎵",
				title: "Melhoria: Envio de Áudios",
				content: "Agora é possível cadastrar e enviar áudios em diversos formatos (OGG, M4A, WAV, AAC, MP3 etc.). ao salvar a mídia o sistema converte automaticamente para MP3 quando necessário, garantindo compatibilidade com o WhatsApp e evitando falhas silenciosas no envio. A conversão não ocorre mais no momento do envio, reduzindo latência nas mensagens subsequentes.",
				isHighlight: true
			}
		]
	},
	{
		version: "3.10.2",
		changes: [
			{
				icon: "🤖",
				title: "Novo Modelo GPT-5.2",
				content: "Adicionado suporte ao GPT-5.2, a versão mais recente do modelo da OpenAI com melhorias em raciocínio e compreensão contextual.",
				isHighlight: true
			},
			{
				icon: "🔍",
				title: "Correção: Web Search no oZapAI",
				content: "Corrigido bug onde o oZapAI não conseguia realizar pesquisas na web. Agora a funcionalidade de busca funciona corretamente."
			},
			{
				icon: "🔧",
				title: "Correção: Erro ao Alterar Store da OpenAI",
				content: "Corrigido problema no gerenciamento de stores da OpenAI que causava erro ao tentar modificar uma base de conhecimento existente."
			}
		]
	},
	{
		version: "3.10.1",
		changes: [
			{
				icon: "🐛",
				title: "Correção: IA Bloqueada Após Notificação",
				content: "Corrigido bug crítico onde a IA não conseguia voltar a responder após enviar notificação de atendimento humano, mesmo quando não houve intervenção real ou a opção estava desativada.",
			},
			{
				icon: "⚙️",
				title: "Controle de Pausa Após Pedir Atendimento",
				content: "Nova opção para escolher se a IA deve parar de responder após solicitar atendimento humano ou continuar a conversa normalmente."
			},
			{
				icon: "⏱️",
				title: "Duração Configurável da Pausa",
				content: "Agora você pode definir por quanto tempo a IA ignora a conversa após pedir atendimento: 1h, 6h, 12h, 24h, 48h, 72h ou permanentemente."
			},
			{
				icon: "📋",
				title: "Resumo da Conversa no Alerta",
				content: "Nova opção que faz a IA gerar um resumo curto da conversa (até 200 caracteres) para contextualizar o alerta de atendimento humano enviado."
			},
			{
				icon: "📝",
				title: "Regras Personalizadas para Intervenção Humana",
				content: "Agora você pode personalizar as regras de quando a IA deve solicitar atendimento humano. Por exemplo: transferir apenas se o cliente demonstrar interesse de compra, ou criar condições específicas para o seu negócio."
			}
		]
	},
	{
		version: "3.10.0",
		changes: [
			{
				icon: "🚨",
				title: "Alertas de Atendimento Humano",
				content: "Configure um número para receber alertas quando um cliente precisar de atendimento humano ou quando ocorrer algum problema no envio de mensagens pela IA. Nunca mais perca uma oportunidade de atendimento importante!",
				isHighlight: true
			},
			{
				icon: "🔗",
				title: "Integrações Externas",
				content: "Conecte seu atendimento a qualquer sistema externo! A IA agora pode consultar estoque, verificar status de pedidos, buscar preços e disponibilidade, agendar compromissos e muito mais. É como dar superpoderes para sua IA - ela busca informações em qualquer lugar que você configurar.",
				isHighlight: true
			},
			{
				icon: "🤖",
				title: "oZapAI Aprimorado",
				content: "O oZapAI foi corrigido e agora funciona perfeitamente! Processa áudios (transcreve e responde), analisa imagens enviadas pelos clientes e funciona integrado com as novas integrações externas.",
			}
		]
	},
	{
		version: "3.9.10",
		changes: [
			{
				icon: "🚨",
				title: "Sistema de Alertas por WhatsApp",
				content: "Novo sistema de alertas que envia notificações via WhatsApp quando a IA detecta necessidade de intervenção humana ou quando ocorrem erros críticos (falha na LLM ou erro de envio de mensagem).",
				isHighlight: true
			},
			{
				icon: "🎨",
				title: "Melhorias na Interface de Filtros de Números",
				content: "Aprimorada a interface das seções 'Somente Responder' e 'Não Responder' com melhor espaçamento e organização visual dos elementos.",
			}
		]
	},
	{
		version: "3.9.9",
		changes: [
			{
				icon: "🔧",
				title: "Correção na Seleção de Base de Conhecimento",
				content: "Corrigido um bug onde a base de conhecimento selecionada era deselecionada automaticamente ao fechar e reabrir o aplicativo. Agora a configuração é mantida corretamente entre sessões.",
			},
			{
				icon: "🔗",
				title: "Correção de Links em Áudios",
				content: "Corrigido um problema onde links presentes no meio de mensagens de áudio não eram enviados separadamente como texto. Agora o sistema detecta e envia corretamente os links em mensagens de texto à parte do áudio.",
			}
		]
	},
	{
		version: "3.9.8",
		changes: [
			{
				icon: "👥",
				title: "Responder Menções em Grupos",
				content: "Nova funcionalidade! Agora a IA pode responder automaticamente quando for mencionada em grupos do WhatsApp. Configure detecção por menção direta (@bot) ou por palavra-chave personalizada. Funciona mesmo com filtros de 'Somente Responder' ativos.",
				isHighlight: true
			},
			{
				icon: "📢",
				title: "Postagens Agendadas em Grupos",
				content: "Nova feature de agendamento de postagens em grupos! Crie mensagens programadas para serem enviadas automaticamente em grupos específicos, com suporte a expressões cron para agendamentos recorrentes.",
				isHighlight: true
			},
			{
				icon: "🔧",
				title: "Correção de Mensagens Duplicadas",
				content: "Corrigido um bug onde mensagens apareciam duplicadas na interface após serem enviadas pelo Zap GPT.",
			},
			{
				icon: "🎬",
				title: "Novos Vídeos Tutoriais",
				content: "Adicionados novos vídeos tutoriais para ajudar na configuração e uso das novas funcionalidades do app.",
			}
		]
	},
	{
		version: "3.9.7",
		changes: [
			{
				icon: "📅",
				title: "Correções no Google Calendar",
				content: "Implementado novo serviço do Google Calendar com melhorias na integração e gerenciamento de eventos.",
			},
			{
				icon: "🤖",
				title: "Correções no Twin AI",
				content: "Corrigidos problemas de tipagem e melhorada a estabilidade do Twin AI com configuração dinâmica de deployment.",
			},
			{
				icon: "📱",
				title: "Número de Suporte Atualizado",
				content: "Atualizado o número de contato do suporte da plataforma.",
			}
		]
	},
	{
		version: "3.9.6",
		changes: [
			{
				icon: "📅",
				title: "Correção do Google Calendar",
				content: "Corrigidos problemas de integração com o Google Calendar que impediam o funcionamento correto do agendamento de eventos.",
			},
			{
				icon: "🖼️",
				title: "Correção na Leitura de Imagens",
				content: "Corrigido bug na leitura e processamento de imagens enviadas pelos usuários, garantindo que a IA interprete corretamente o conteúdo visual.",
			},
			{
				icon: "🎯",
				title: "Melhoria na Precisão de Agendamento",
				content: "Aprimorada a precisão do agendamento no Google Calendar. A IA agora identifica horários e datas com maior exatidão, reduzindo erros de interpretação.",
			}
		]
	},
	{
		version: "3.9.5",
		changes: [
			{
				icon: "🤖",
				title: "Novo Modelo GPT-5.1",
				content: "Adicionado suporte ao GPT-5.1, o mais novo modelo da OpenAI com capacidades ainda mais avançadas de raciocínio e compreensão contextual.",
				isHighlight: true
			},
			{
				icon: "🌌",
				title: "Novo Modelo Gemini 3",
				content: "Adicionado suporte ao Gemini 3, a mais recente geração do modelo do Google com melhorias significativas em compreensão e processamento multimodal.",
				isHighlight: true
			},
			{
				icon: "🧠",
				title: "Controles de Verbosidade e Reasoning para GPT-5/5.1",
				content: "Novas opções exclusivas para modelos GPT-5 e GPT-5.1! Configure o nível de verbosidade das respostas e ative o modo de raciocínio (reasoning) para respostas mais elaboradas e fundamentadas.",
			},
			{
				icon: "💭",
				title: "Thinking Level e Media Resolution para Gemini 3",
				content: "Opções exclusivas para Gemini 3! Ajuste o nível de raciocínio (thinking level) para respostas mais profundas e configure a resolução de mídia (media resolution) para otimizar o processamento de imagens e vídeos.",
			},
			{
				icon: "🔍",
				title: "File Search para GPT e Gemini",
				content: "Implementado sistema de busca em arquivos (File Search/Knowledge Base) tanto para GPT quanto para Gemini! Agora ambos os modelos podem pesquisar e referenciar informações de documentos cadastrados na base de conhecimento.",
				isHighlight: true
			},
			{
				icon: "🌐",
				title: "Web Search para GPT e Gemini",
				content: "Funcionalidade de busca na web (Web Search/Grounding) agora disponível para GPT e Gemini! Ambos os modelos podem acessar informações atualizadas da internet e citar fontes nas respostas.",
			}
		]
	},
	{
		version: "3.9.3",
		changes: [
			{
				icon: "🌍",
				title: "Configuração Manual de Fuso Horário por Instância",
				content: "Agora você pode configurar o fuso horário (timezone) de cada instância individualmente! Perfeito para clientes que acessam de diferentes países. A IA usará o timezone configurado para timestamps e agendamentos do Google Calendar. Suporte para 33 timezones incluindo todas as Américas, Europa, Ásia e África.",
			}
		]
	},
	{
		version: "3.9.2",
		changes: [
			{
				icon: "🔧",
				title: "Correção de Duplicação de Chats",
				content: "Corrigido bug crítico onde chats apareciam duplicados na listagem devido ao mapeamento incorreto entre formatos LID e PN do WhatsApp. Sistema agora normaliza identificadores automaticamente e deduplicata chats existentes.",
			},
			{
				icon: "🛠️",
				title: "Correção na Intervenção Humana",
				content: "Corrigido problema onde a funcionalidade de intervenção humana não estava funcionando corretamente devido à falta do parâmetro append nas mensagens.",
			}
		]
	},
	{
		version: "3.9.0",
		changes: [
			{
				icon: "🤖",
				title: "Novos Modelos do Gemini",
				content: "Atualizada a lista de modelos do Gemini com os mais recentes e removidos os modelos depreciados, garantindo melhor performance e compatibilidade.",
			},
			{
				icon: "🔍",
				title: "Web Search com Gemini (Grounding)",
				content: "Nova funcionalidade! Agora você pode ativar a busca na web (Web Search/Grounding) para o Gemini, permitindo que a IA acesse informações atualizadas da internet e cite suas fontes automaticamente nas respostas.",
				isHighlight: true
			},
			{
				icon: "🔄",
				title: "Simplificação da API do OpenAI",
				content: "Removida a complexidade da Assistants API do OpenAI. Agora o sistema usa exclusivamente a Chat Completions API, oferecendo melhor compatibilidade com todas as funcionalidades (Google Calendar, mídias, functions customizadas) e respostas mais rápidas.",
			},
			{
				icon: "💡",
				title: "Exemplos de Prompts",
				content: "Adicionada opção de visualizar prompts de exemplo nos modais de criação de prompt, facilitando o aprendizado e criação de instruções mais efetivas para a IA.",
			}
		]
	},
	{
		version: "3.8.6",
		changes: [
			{
				icon: "🔧",
				title: "Correção: Lista 'Somente Responder' Não Funcionava",
				content: "Corrigido um bug onde números configurados na lista 'Somente Responder' não eram reconhecidos pelo sistema, fazendo com que a IA não respondesse contatos autorizados. Agora a detecção funciona corretamente para todos os números cadastrados.",
			}
		]
	},
	{
		version: "3.8.5",
		changes: [
			{
				icon: "🛠️",
				title: "Correção de Bug no QR Code",
				content: "Corrigido um bug onde o QR Code não era exibido corretamente para conectar ao WhatsApp.",
			}
		]
	},
	{
		version: "3.8.4",
		changes: [
			{
				icon: "🛡️",
				title: "Proteção Contra Perda de Mídias Cadastradas",
				content: "Implementado sistema automático de backup e recuperação que protege suas mídias cadastradas. Agora o sistema cria backups automáticos antes de qualquer mudança, detecta se mídias estão em outro diretório e oferece recuperação automática. Suas mídias cadastradas estão 100% protegidas contra perda acidental.",
			}
		]
	},
	{
		version: "3.8.3",
		changes: [
			{
				icon: "🔧",
				title: "Erros de IA Mascarados em Follow-up",
				content: "Corrigido um bug crítico onde erros da API da IA (como modelo não disponível, chave de API inválida, problemas de conexão) eram mostrados como 'cliente não precisa de follow-up' em vez de exibir o erro real.",
				isHighlight: true
			}
		]
	},
	{
		version: "3.8.2",
		changes: [
			{
				icon: "⚡",
				title: "Cancelar Respostas ao Receber Nova Mensagem",
				content: "Nova opção inteligente! Quando ativada, se a IA estiver enviando múltiplas mensagens e o usuário enviar uma nova mensagem, o sistema cancela automaticamente a fila antiga e processa o novo contexto imediatamente com resposta 50% mais rápida. Isso proporciona uma experiência mais fluida e responsiva nas conversas.",
				isHighlight: true
			},
			{
				icon: "🔧",
				title: "Correções na Intervenção Humana",
				content: "Aprimorada a detecção e gerenciamento de intervenção humana, garantindo maior precisão na identificação de quando um atendente assume a conversa manualmente."
			}
		]
	},
	{
		version: "3.8.1",
		changes: [
			{
				icon: "🔧",
				title: "Ajustes no Twin AI",
				content: "Realizados ajustes e melhorias no Twin AI para garantir respostas mais precisas e estáveis."
			}
		]
	},
	{
		version: "3.8.0",
		changes: [
			{
				icon: "🤖",
				title: "Twin AI - IA Gratuita Sem Chave de API",
				content: "Agora você pode usar o Twin AI, nossa própria IA completamente gratuita que não precisa de chave de API! Aproveite respostas inteligentes, processamento de áudio e imagens sem custos adicionais. Basta selecionar Twin AI nas configurações e começar a usar.",
				isHighlight: true
			}
		]
	},
	{
		version: "3.7.1",
		changes: [
			{
				icon: "🔧",
				title: "Correção Crítica: Mídias da IA Sumindo",
				content: "Corrigido um bug crítico onde mídias cadastradas em batch (grupos de múltiplas mídias) desapareciam inesperadamente. O problema ocorria porque a função de limpeza de arquivos órfãos identificava incorretamente arquivos de grupos como não registrados e os deletava do disco. Agora as funções cleanupOrphanedFiles, getAIMediaStorageStats e validateMediaIntegrity processam corretamente tanto mídias individuais quanto grupos, garantindo que suas mídias cadastradas permaneçam seguras.",
			},
			{
				icon: "🧠",
				title: "Correção: Perda de Memória do Gemini com Imagens",
				content: "Corrigido um bug no Gemini onde a IA perdia completamente o contexto da conversa quando havia imagens presentes, seja de imagens enviadas pelo usuário ou de mídias cadastradas enviadas pela própria IA. Agora o Gemini mantém corretamente toda a memória da conversa mesmo ao processar e enviar imagens, lembrando de informações anteriores e garantindo uma experiência de conversação fluida e coerente."
			}
		]
	},
	{
		version: "3.7.0",
		changes: [
			{
				icon: "🚀",
				title: "Migração para Baileys v7 - Fim dos Chats Duplicados",
				content: "Migração crítica para Baileys v7 com unificação completa dos sistemas JID e LID do WhatsApp. Isso elimina definitivamente o problema de chats duplicados que alguns usuários enfrentavam, onde o mesmo contato aparecia duas vezes na lista. Implementada normalização automática de identificadores para garantir uma experiência mais limpa e organizada.",
				isHighlight: true
			},
			{
				icon: "🔒",
				title: "Correção: Múltiplas Janelas de Seleção de Mídia",
				content: "Corrigido problema onde clicar múltiplas vezes no botão de seleção de arquivos de mídia abria várias janelas simultaneamente. Implementado sistema de proteção contra múltiplos cliques com feedback visual e desabilitação automática dos botões durante a seleção."
			}
		]
	},
	{
		version: "3.6.5",
		changes: [
			{
				icon: "🛡️",
				title: "Correção Crítica: Falsos Positivos de Intervenção Humana",
				content: "Corrigido um bug onde o sistema detectava incorretamente intervenções humanas em mensagens automatizadas do próprio bot (follow-ups, áudios da IA, links enviados pela IA). Implementado rastreamento completo de IDs de mensagens em todos os sistemas automatizados e aumentado o TTL do cache para 24 horas, eliminando completamente os falsos positivos.",
				isHighlight: true
			}
		]
	},
	{
		version: "3.6.4",
		changes: [
			{
				icon: "🧠",
				title: "Correção: Memória da IA com Envio de Mídias",
				content: "Corrigido um bug onde a IA perdia o contexto da conversa ao enviar mídias cadastradas. Agora a IA mantém corretamente toda a memória da conversa, lembrando de informações anteriores mesmo após enviar imagens, vídeos ou documentos."
			}
		]
	},
	{
		version: "3.6.3",
		changes: [
			{
				icon: "🔧",
				title: "Correção Crítica: Duplicação de Follow-ups",
				content: "Resolvido completamente o bug intermitente onde mensagens de follow-up eram enviadas em duplicata. Implementados mutex robustos, IDs únicos criptograficamente seguros e correção de race conditions no processamento de follow-ups retroativos e agendamento automático."
			},
			{
				icon: "⏰",
				title: "Correção: Timer de Follow-up Zerado na UI",
				content: "Corrigido bug onde o timer de verificação automática de follow-up mostrava '0h 00m' na interface mesmo funcionando internamente. Agora exibe corretamente o tempo restante (ex: '10m', '50s') com formatação inteligente baseada na duração."
			},
			{
				icon: "🔧",
				title: "Correções em Bugs de Intervenção Humana",
				content: "Corrigidos problemas na funcionalidade de intervenção humana e toggle de IA nos chats."
			}
		]
	},
	{
		version: "3.6.2",
		changes: [
			{
				icon: "🎵",
				title: "Correção: Contexto Unificado entre Áudio e Texto",
				content: "Corrigido um bug crítico onde a IA não compartilhava o mesmo histórico de conversa entre mensagens de áudio e texto ao usar Gemini. Agora todas as mensagens (áudio e texto) são processadas através do mesmo sistema de buffer, garantindo que o contexto da conversa seja mantido independente do tipo de mensagem. A funcionalidade de resposta automática em áudio continua funcionando normalmente.",
			},
			{
				icon: "🔧",
				title: "Correção Crítica: Intervenção Humana Permanentemente Bloqueada",
				content: "Corrigido um bug crítico onde chats com intervenção humana anterior ficavam permanentemente bloqueados, impedindo nova detecção de intervenção. Agora o sistema renova automaticamente o tempo de intervenção quando o usuário continua enviando mensagens manuais, evitando que conversas fiquem travadas indefinidamente.",
			},
			{
				icon: "📎",
				title: "Correção: Validação de Nomes de Mídia para IA",
				content: "Corrigido erro onde usuários cadastravam mídias com nomes muito longos ou caracteres especiais, causando falhas no GPT (erro 400 'string too long'). Agora o sistema valida automaticamente títulos (máx. 50 caracteres) e descrições (máx. 200 caracteres), remove acentos, mostra preview do nome da função em tempo real e adiciona avisos sobre limitações. Também foi melhorada a sanitização no backend para garantir nomes sempre válidos.",
			},
			{
				icon: "⚠️",
				title: "Aviso: Envio de Mídia Indisponível com Assistant API",
				content: "Adicionado aviso claro no diálogo de configurações do GPT informando que o envio de mídias com IA não funciona quando usando Assistant API. Para usar esta funcionalidade, é necessário remover o Assistant ID e usar a Nova API (Responses API)."
			},
			{
				icon: "⏰",
				title: "Correção: Formatação Inconsistente do Tempo de Reativação",
				content: "Corrigida inconsistência na exibição do tempo de reativação da IA após intervenção humana. Anteriormente mostrava formatos diferentes (24h 00m vs 59:30), causando confusão. Agora sempre exibe no formato padronizado 'Xh Ym' para maior clareza."
			},
			{
				icon: "📋",
				title: "Logs Melhorados para Debug de Intervenção",
				content: "Adicionados logs detalhados com indicadores visuais (🚫, ✅, 🔄) para facilitar investigação de problemas de intervenção humana. Incluídos contadores de chats ativos e diferenciação entre intervenção nova vs renovação."
			}
		]
	},
	{
		version: "3.6.1",
		changes: [
			{
				icon: "📎",
				title: "Envio de Mídia em Lote",
				content: "Agora é possível enviar múltiplas mídias de uma vez, tanto pela IA quanto pelo chat integrado. Suporta fotos, imagens, vídeos e documentos em lote, tornando o envio de conteúdo ainda mais eficiente.",
				isHighlight: true
			},
			{
				icon: "🔄",
				title: "Sincronização do Botão de IA",
				content: "O botão de ativar/desativar IA na listagem dos chats agora está sempre sincronizado com o mesmo botão no cabeçalho do chat, evitando inconsistências visuais e funcionais."
			},
			{
				icon: "🔧",
				title: "Correção de Falsa Intervenção Humana",
				content: "Corrigido um bug crítico onde o sistema detectava incorretamente intervenções humanas em chats que não tiveram intervenção real, especialmente com mensagens de áudio antigas re-sincronizadas pelo Baileys. Agora o sistema ignora mensagens mais antigas que 5 minutos e mensagens de áudio PTT para evitar falsos positivos."
			},
			{
				icon: "🎵",
				title: "Correção do ID de Voz ElevenLabs",
				content: "Corrigido problema onde IDs de vozes personalizadas do ElevenLabs não eram armazenados corretamente. Agora o sistema detecta automaticamente se a voz é personalizada e sincroniza corretamente a interface da modal com as configurações salvas."
			},
			{
				icon: "🔧",
				title: "Atualização do Baileys para v6.7.19",
				content: "Atualizada a biblioteca do WhatsApp para a versão mais recente, incluindo melhorias na estabilidade de conexão, validação aprimorada de URLs de mídia, melhor tratamento de erros de socket e suporte expandido para comunidades e grupos."
			},
			{
				icon: "🆔",
				title: "Suporte aos Novos IDs de Privacidade do WhatsApp",
				content: "Adicionado suporte aos novos identificadores @lid do WhatsApp, que são usados para proteger a privacidade dos usuários em grupos e comunidades. O sistema agora reconhece e processa corretamente mensagens de usuários com IDs no formato @lid, garantindo compatibilidade total com as atualizações de privacidade do WhatsApp."
			}
		]
	},
	{
		version: "3.6.0",
		changes: [
			{
				icon: "📎",
				title: "Envio de Mídia pela IA",
				content: "Agora a IA pode enviar fotos, imagens, vídeos e documentos diretamente nas conversas do WhatsApp, tornando as interações ainda mais completas e dinâmicas.",
				isHighlight: true
			},
			{
				icon: "📎",
				title: "Envio de Mídia pelo Chat",
				content: "Agora você também pode enviar fotos, imagens, vídeos e documentos diretamente pelo chat integrado do app, tornando a comunicação ainda mais prática e completa."
			}
		]
	},
	{
		version: "3.5.1",
		changes: [
			{
				icon: "🔁",
				title: "Exportar/Importar Números",
				content: "Adicionada a opção de exportar e importar listas nas seções 'Somente responder' e 'Não responder', facilitando backup e migração."
			},
			{
				icon: "🔒",
				title: "Privacidade no Google Calendar",
				content: "Corrigido um problema onde a IA tinha acesso a informações de outras reuniões. Agora o acesso fica limitado apenas ao necessário para o agendamento."
			}
		],
	},
	{
		version: "3.5.0",
		changes: [
			{
				icon: "📅",
				title: "Melhorias no Google Calendar",
				content: "Corrigidos problemas onde a IA mostrava horários já reservados como disponíveis, marcava horários diferentes dos solicitados e a integração aparecia conectada quando não estava. Agora mostra horários livres e reuniões do dia (ao invés da semana toda) nas abas da seção do Google Calendar.",
				isHighlight: true
			},
			{
				icon: "🎯",
				title: "Personalização de Agendamentos",
				content: "Adicionadas opções de título personalizado para agendamentos, mensagem personalizada quando o agendamento é marcado e configuração de email obrigatório ou opcional."
			},
			{
				icon: "🤖",
				title: "Novos Modelos GPT-5",
				content: "Adicionados os novos modelos GPT-5 como opção para utilizar no app."
			},
			{
				icon: "💾",
				title: "Botão de Salvar Fixo",
				content: "O botão de salvar agora fica fixo no menu para facilitar o ajuste das configurações sem precisar rolar até embaixo da página."
			},
			{
				icon: "📱",
				title: "Exibição do Número Conectado",
				content: "Agora aparece o número conectado no WhatsApp embaixo do status da conexão na página central."
			},
		],
	},
	{
		version: "3.4.1",
		changes: [
			{
				icon: "🔧",
				title: "Correção Urgente do QR Code",
				content: "Corrigido um bug urgente onde o QR Code não aparecia para conectar no WhatsApp."
			}
		],
	},
	{
		version: "3.4.0",
		changes: [
			{
				icon: "🎵",
				title: "Audio com IA",
				content: "Nova funcionalidade! O assistente agora manda áudios de forma humanizada com timing realista usando Gemini, GPT ou ElevenLabs.",
				isHighlight: true
			},
			{
				icon: "🔗",
				title: "Detecção Inteligente de Links no Áudio",
				content: "O sistema detecta automaticamente links no texto e os envia separadamente como mensagens de texto, falando apenas o conteúdo relevante no áudio."
			},
			{
				icon: "⚙️",
				title: "TTS Como Ferramenta Configurável",
				content: "Nova opção no Dashboard: 'Áudio como Ferramenta' permite que a IA decida quando enviar áudio baseado na solicitação do usuário, tornando a experiência mais natural."
			},
			{
				icon: "🎧",
				title: "Player de Áudio Visual no Chat",
				content: "Agora você pode ouvir diretamente no chat todos os áudios! Player visual completo com controles de play/pause, barra de progresso clicável e design diferenciado por tipo: áudios da IA (roxo), seus áudios (verde) e áudios recebidos (amarelo). Funciona para todos os áudios enviados e recebidos."
			},
			{
				icon: "🔄",
				title: "Correção de Google Calendar (GPT)",
				content: "Corrigido um bug onde o Google Calendar não estava funcionando corretamente usando a IA da OpenAI."
			}
		],
	},
	{
		version: "3.3.3",
		changes: [
			{
				icon: "🤖",
				title: "Nova API de Responses da OpenAI",
				content: "Implementada a nova Responses API da OpenAI, trazendo respostas mais rápidas e inteligentes.",
				isHighlight: true
			},
			{
				icon: "🔄",
				title: "Correção no Follow Up",
				content: "A funcionalidade de follow up foi corrigida para garantir reengajamento automático sem falhas."
			},
			{
				icon: "🎨",
				title: "Redesign da Tela Principal",
				content: "A tela principal foi totalmente redesenhada para uma experiência mais moderna e intuitiva.",
			},
			{
				icon: "📅",
				title: "Suporte ao Google Calendar com GPT",
				content: `Agora o ${APP_NAME} interage com seu Google Calendar usando GPT, agendando e gerenciando eventos de forma ainda mais inteligente.`
			}
		],
	},
	{
		version: "3.3.0",
		changes: [
			{
				icon: "📅",
				title: "Integração com Google Calendar",
				content: `Conecte seu Google Calendar ao ${APP_NAME} e deixe o bot agendar reuniões automaticamente — sem sair do WhatsApp. ⏰`,
				isHighlight: true
			},
			{
				icon: "✨",
				title: "Nova animação de conexão",
				content: "Ao escanear o QR Code, uma animação fluida mostra o progresso da conexão, tornando o onboarding mais claro e envolvente."
			},
			{
				icon: "🗂️",
				title: "Lista de conversas retrátil + Scrollbar estilizada",
				content: "Recolha ou expanda a lista de conversas e deslize por uma barra de rolagem novinha em folha — mais suave e estilosa para navegar entre atendimentos."
			},
			{
				title: "Novos modelos do Gemini",
				content: "Adicionados os modelos Gemini 2.5 Flash e Gemini 2.5 Pro.",
				icon: "🤖"
			},
			{
				icon: "🔕",
				title: "Opção de desativar a intervenção humana",
				content: "Quando você dispara mensagens para vários leads, a intervenção manual pode pausar os chats de todos eles. Agora basta desativá‑la e deixar a IA responder sem interrupções."
			}
		],
	},
	{
		version: "3.2.1",
		changes: [
			{
				icon: "🔄",
				title: "Correção bug de follow up",
				content: "Corrigido um bugs encontrados no follow up.",
			},
			{
				title: "Logs corrigidos",
				content: "Os logs não estavam sendo exibidos corretamente, agora estão funcionando como esperado.",
				icon: "📜"
			},
			{
				title: "Melhorias visuais no chat",
				content: "O chat integrado recebeu melhorias visuais para uma experiência mais agradável",
				icon: "🎨"
			}
		],
	},
	{
		version: "3.2.0",
		changes: [
			{
				icon: "🔄",
				title: "Follow up inteligente com IA",
				content: "Nova funcionalidade! A IA agora analisa automaticamente as conversas após o cliente parar de responder e decide de forma inteligente se deve enviar uma mensagem de follow up. Você pode configurar mensagens personalizadas, adicionar promoções e criar estratégias de reengajamento totalmente customizadas.",
				isHighlight: true
			},
			{
				icon: "🗑️",
				title: "Apagar conversas de chat específico",
				content: "Agora é possível apagar conversas de chat específico, facilitando a limpeza de conversas antigas e inativas."
			},
			{
				icon: "📊",
				title: "Tela de Métricas",
				content: "Adicionada nova tela de métricas com informações detalhadas como mensagens enviadas pela IA, mensagens processadas pelo bot, follow ups enviados por instância e muito mais para acompanhar o desempenho do seu bot."
			},
			{
				icon: "🤖",
				title: "Correção no Modo IA do Chat",
				content: "Ajustado o funcionamento do modo IA no chat integrado. Agora, quando o modo IA está ativo, isso garante com certeza que aquele chat específico está sendo respondido pela IA, eliminando conflitos com outras configurações como 'responder somente um número'."
			}
		],
	},
	{
		version: "3.1.1",
		changes: [
			{
				icon: "🛠️",
				title: "Correção do Bug de Intervenção Humana Imediata",
				content: "Corrigido um problema onde a IA não respondia a novos contatos após o app ser reiniciado, interpretando incorretamente que já havia ocorrido uma intervenção humana. A verificação agora é feita apenas pelo estado atual da sessão, sem considerar o histórico armazenado."
			},
			{
				icon: "🔄",
				title: "Correção de Instabilidade na Conexão",
				content: "Resolvido um bug que causava problemas de instabilidade onde o WhatsApp ficava conectando e desconectando sem parar, melhorando a estabilidade geral da aplicação."
			},
			{
				icon: "🎬",
				title: "Novos Vídeos Tutoriais",
				content: "Adicionados novos vídeos tutoriais para configurações de conversas, importação de informações, criação de instâncias, instalação no Windows e criação de prompts, organizados em categorias para facilitar o aprendizado."
			}
		]
	},
	{
		version: "3.1.0",
		changes: [
			{
				icon: "🛠️",
				title: "Correção na Detecção de Intervenção Humana",
				content: "Corrigido um problema intermitente onde o sistema às vezes não detectava corretamente a intervenção humana. A aplicação agora gerencia melhor o rastreamento de mensagens por instância."
			},
			{
				icon: "🔘",
				title: "Nova Opção de Intervenção Manual",
				content:
					"Adicionada a opção \"Não responder após mensagem manual\" que impede a IA de responder conversas que você iniciou primeiro. Recomendado manter DESATIVADA para quem faz disparos de campanhas no WhatsApp, pois a IA não conseguirá responder leads que entrarem em contato após seu disparo inicial.",
			},
			{
				icon: "🔍",
				title: "Filtro de Conversas Vazias",
				content:
					"Implementado um filtro inteligente que oculta conversas sem mensagens, melhorando a organização e evitando a exibição de chats desnecessários na interface.",
			},
			{
				icon: "☎️",
				title: "Correção para Números Inválidos",
				content:
					"Adicionada validação para evitar o envio de mensagens para números em formato incorreto ou não reconhecido pelo WhatsApp.",
			},
			{
				icon: "📚",
				title: "Página de Tutoriais",
				content:
					`Adicionada uma página de tutoriais completos sobre o uso do ${APP_NAME} diretamente dentro do app, facilitando o aprendizado de todas as funcionalidades.`,
			},
			{
				icon: "🔔",
				title: "Exibição Detalhada de Erros de IA",
				content:
					"Agora os erros de conexão com a IA são exibidos com detalhes específicos, permitindo identificar melhor os problemas quando a IA não responde.",
			},
			{
				icon: "🔴",
				title: "Erros de IA em Destaque nos Logs",
				content:
					"Os erros relacionados à IA agora aparecem em vermelho nos logs, tornando-os mais visíveis para análise e solução rápida de problemas.",
			},
			{
				icon: "🔄",
				title: "Correção no Carregamento da Conexão",
				content:
					"Resolvido o problema onde a conexão ficava carregando infinitamente sem estabelecer contato com o WhatsApp.",
			},
		],
	},
	{
		version: "3.0.1",
		changes: [
			{
				icon: "🚪",
				title: "Correção no Botão de Logout",
				content:
					"Corrigido um problema onde o botão de logout não funcionava corretamente, impedindo a desconexão do WhatsApp.",
			},
			{
				icon: "📋",
				title: "Correção ao Copiar Configurações entre Instâncias",
				content:
					"Resolvido um bug onde, em alguns casos, o app travava ao importar configurações de uma instância para outra.",
			},
			{
				icon: "🎯",
				title: "Foco Automático no Chat Após Envio",
				content:
					"Após enviar uma mensagem no novo chat integrado, o foco agora retorna automaticamente para a caixa de texto, facilitando o envio de mensagens seguidas.",
			},
		],
	},
	{
		version: "3.0.0",
		changes: [
			{
				icon: "🚀",
				title: "Redesign Visual Completo",
				content:
					"Interface totalmente reformulada para proporcionar uma experiência mais fluida e intuitiva aos usuários.",
			},
			{
				icon: "💬",
				title: "Novo Chat Integrado",
				content:
					"Agora o app possui um chat espelho do WhatsApp! Nele, é possível configurar manualmente quais chats a IA deve responder, visualizar chats inativos por intervenção humana e enviar mensagens de texto (beta).",
			},
			{
				icon: "🛠️",
				title: "Refatoração da Lógica de Tratamento de Mensagens",
				content:
					"O código responsável pelo processamento das mensagens foi completamente reestruturado, melhorando a estabilidade do app e garantindo o funcionamento correto da intervenção humana.",
			},
			{
				icon: "🤖",
				title: "Escolha Personalizada de Modelos e Temperaturas do Gemini",
				content:
					"Agora é possível selecionar diferentes modelos do Gemini e ajustar a temperatura diretamente no aplicativo, oferecendo maior controle sobre as respostas da IA.",
			},
			{
				icon: "🧠",
				title: "Gerenciamento de Assistentes da OpenAI",
				content:
					`O ${APP_NAME} agora permite configurar seus assistentes personalizados da OpenAI! É possível alterar prompts, temperatura, top-p e até mesmo escolher o modelo do assistente diretamente no app.`,
			},
			{
				icon: "📩",
				title: "Fila de Mensagens para Melhor Coerência",
				content:
					"Implementamos um sistema de filas para garantir que as mensagens sejam processadas na ordem correta. Isso melhora a fluidez das respostas da IA, evitando confusão entre diferentes assuntos.",
			},
		],
	},
	{
		version: "2.0.6",
		changes: [
			{
				icon: "🔧",
				title: "Correção no Envio de Metadados para a IA",
				content:
					"Corrigido um problema onde a IA incluía informações de metadados na resposta final enviada ao usuário.",
			},
			{
				icon: "⚙️",
				title: "Nova Opção para Incluir ou Não o Nome do Contato",
				content:
					"Agora é possível configurar se a IA deve receber ou não o nome do contato do WhatsApp, permitindo maior personalização no processamento das respostas.",
			},
		],
	},
	{
		version: "2.0.5",
		changes: [
			{
				icon: "⏰",
				title: "Correção na Exibição de Dados de Horário",
				content:
					"Corrigido um problema onde a IA mencionava horários e datas de mensagens que não deveria.",
			},
			{
				icon: "📝",
				title: "Melhoria na Tela de Logs",
				content:
					"A tela de logs foi aprimorada para exibir informações de forma mais organizada e clara, facilitando a análise de eventos.",
			},
			{
				icon: "🚫",
				title: "Correção para evitar abertura de múltiplas janelas",
				content:
					`Agora o ${APP_NAME} impede que o aplicativo seja aberto mais de uma vez ao mesmo tempo. Se já houver uma janela em execução, ela será trazida para frente.`,
			},
		],
	},
	{
		version: "2.0.4",
		changes: [
			{
				icon: "🔒",
				title: "Correções de Segurança",
				content:
					"Atualizações para melhorar a segurança da aplicação.",
			},
		],
	},
	{
		version: "2.0.3",
		changes: [
			{
				icon: "🎨",
				title: "Melhorias Visuais no Login",
				content:
					"A tela de login recebeu melhorias visuais para uma experiência mais fluida e intuitiva.",
			},
			{
				icon: "🆘",
				title: "Botão de Suporte via WhatsApp",
				content:
					"Agora há um botão de suporte na tela de login para facilitar o contato com a equipe pelo WhatsApp.",
			},
			{
				icon: "👀",
				title: "Opção para Visualizar ou Não Mensagens",
				content:
					"Agora é possível configurar se o bot deve visualizar as mensagens recebidas ou não.",
			},
			{
				icon: "💬",
				title: "Envio de Respostas em Mensagem Única",
				content:
					"Nova opção permite que o bot envie toda a resposta em uma única mensagem, sem dividir em partes.",
			},
			{
				icon: "⚡",
				title: "Novo Modal para Configurar Velocidade das Respostas",
				content:
					"Adicionado um modal que permite ajustar a velocidade das respostas do bot de acordo com a preferência do usuário.",
			},
			{
				icon: "🤖",
				title: "Correção no Envio de Mensagens em Grupos",
				content:
					"Corrigido um problema onde o bot enviava mensagens indevidas em grupos.",
			},
			{
				icon: "🔒",
				title: "Melhoria no Servidor para Maior Estabilidade",
				content:
					"Aprimorada a infraestrutura do servidor para evitar que alguns usuários sejam deslogados automaticamente.",
			},
		],
	},
	{
		version: "2.0.2",
		changes: [
			{
				icon: "🔌",
				title: "Botão de Desconectar WhatsApp",
				content:
					"Agora há um botão para desconectar ou fazer logout da conexão com o WhatsApp diretamente pelo app.",
			},
			{
				icon: "🔑",
				title: "Recuperação de Senha",
				content:
					"Agora há um botão de 'Esqueci minha senha' na tela de login, permitindo redefinir a senha diretamente pelo app.",
			},
			{
				icon: "📅",
				title: "Exibição da Data de Acesso",
				content:
					`O Dashboard agora exibe até quando você tem acesso ao ${APP_NAME}.`,
			},
			{
				icon: "🚪",
				title: "Correção no Logout",
				content:
					"Corrigido o problema onde alguns usuários eram deslogados automaticamente sem motivo.",
			},
			{
				icon: "🔗",
				title: "Correção na Conexão Persistente",
				content:
					"Corrigido um erro onde a conexão permanecia ativa mesmo após o logout, garantindo maior segurança.",
			},
			{
				icon: "📊",
				title: "Monitoramento de Erros na API",
				content:
					"O sistema agora monitora erros na nossa API para melhor estabilidade e diagnóstico.",
			},
			{
				icon: "🤖",
				title: "Correção no Envio de Mensagens em Grupos",
				content:
					"Corrigido o bug onde o bot enviava algumas mensagens indevidas em grupos.",
			},
			{
				icon: "📝",
				title: "Exibição de Erros de Conexão com IA nos Logs",
				content:
					"Agora os logs exibem erros de conexão com a IA para facilitar o diagnóstico e solução de problemas.",
			},
			{
				icon: "⏰",
				title: "Correção na Consciência de Data e Hora",
				content:
					"Corrigido um erro onde, em alguns casos, o bot não sabia a data, hora ou o dia da semana corretamente.",
			},
		],
	},
	{
		version: "2.0.1",
		changes: [
			{
				icon: "🔒",
				title: "Correções de segurança",
				content: "-",
			},
		],
	},
	{
		version: "2.0.0",
		changes: [
			{
				icon: "🌌",
				title: "Adição do Gemini",
				content:
					`Agora o ${APP_NAME} conta com suporte ao modelo Gemini, trazendo ainda mais poder para as respostas! E já conta com entedimento de imagem e áudio.`,
			},
			{
				icon: "🔒",
				title: "Autenticação",
				content:
					`Adicionada autenticação ao ${APP_NAME}, garantindo que apenas usuários autorizados tenham acesso às funcionalidades.`,
			},
			{
				icon: "✂️",
				title: "Correção na divisão de mensagens",
				content:
					"Ajustada a lógica de envio para evitar cortes incorretos e garantir uma experiência mais fluida.",
			},
			{
				icon: "🚫",
				title: "Prevenção de links no formato errado",
				content:
					"Agora o modelo bloqueia links mal formatados no estilo `[]()` para evitar mensagens quebradas.",
			},
			{
				icon: "✨",
				title: "Melhorias no layout e usabilidade",
				content:
					"Layout atualizado para maior clareza e uma experiência mais intuitiva ao usuário.",
			},
			{
				icon: "📤",
				title: "Melhoria no envio de mensagens",
				content:
					"Mensagens agora são enviadas de forma ainda mais eficiente, com tempos de resposta otimizados.",
			},
			{
				icon: "🤝",
				title: "Identificação de contatos pelo nome",
				content:
					`O ${APP_NAME} agora sabe o nome do contato com quem está interagindo, permitindo respostas ainda mais personalizadas.`,
			},
		],
	},
	{
		version: "1.0.6",
		changes: [
			{
				icon: "🔧",
				title: "Correção nas conexões",
				content:
					"Corrigido um problema raro onde a aplicação ficava conectando e desconectando do WhatsApp continuamente.",
			},
			{
				icon: "⚠️",
				title: "Configurações Não Salvas",
				content:
					"Agora, sempre que você alterar uma configuração e não salvá-la, um aviso aparecerá para lembrar que as mudanças não foram aplicadas.",
			},
			{
				icon: "🔄",
				title: "Importar Configurações de Outra Conta",
				content:
					"Agora, ao criar uma nova conta, você pode copiar rapidamente as configurações de uma conta já existente com o botão de importar. Isso facilita a configuração e garante que todas as preferências e ajustes estejam prontos com apenas um clique.",
			},
			{
				icon: "🖋️",
				title: "Melhoria na exibição de botões de instância",
				content:
					"Botões de edição e exclusão reposicionados para melhorar o layout, com instância selecionada agora desabilitada para uma interação mais intuitiva.",
			},
		],
	},
	{
		version: "1.0.5",
		changes: [
			{
				icon: "🔧",
				title: "Correção no gerenciamento de contas",
				content:
					"Agora é possível renomear e apagar contas (instâncias) que foram criadas anteriormente.",
			},
			{
				icon: "🚀",
				title: "Atualização automática para Linux e macOS",
				content:
					"O aplicativo agora atualiza automaticamente para novas versões em Linux e macOS, garantindo sempre as últimas melhorias e correções, sem precisar de download manual.",
			},
			{
				icon: "📝",
				title: "Visualização de logs em tempo real",
				content:
					"Adicionado um botão de logs que abre um modal mostrando os logs da aplicação em tempo real, facilitando o monitoramento e a análise do sistema.",
			},
		],
	},
	{
		version: "1.0.4",
		changes: [
			{
				icon: "🔧",
				title: "Correção na leitura de imagem",
				content: "A transcrição de imagens não estava funcionando",
			},
		],
	},
	{
		version: "1.0.3",
		changes: [
			{
				icon: "🚀",
				title: "Atualização no gerenciamento de contas",
				content:
					"Agora o aplicativo pode controlar múltiplos WhatsApps de forma centralizada, sem a necessidade de abrir mais de uma instância.",
			},
			{
				icon: "⏰",
				title: "Consciência de horário e dia",
				content:
					"Agora o assistente tem consciência das horas e do dia da semana, podendo responder de forma mais contextualizada.",
			},
		],
	},
	{
		version: "1.0.2",
		changes: [
			{
				icon: "🔄",
				title: "Correção de múltiplas instâncias",
				content:
					"Correção para o software poder abrir em mais de uma instância.",
			},
			{
				icon: "📃",
				title: "Log de atualizações",
				content:
					"Adicionada a funcionalidade de mostrar o log de atualizações.",
			},
		],
	},
	{
		version: "1.0.1",
		changes: [
			{
				icon: "🎧",
				title: "Correção na interpretação de áudio",
				content:
					"Correção na interpretação de áudio que não estava funcionando corretamente.",
			},
		],
	},
];
